import React from 'react';

const HealthCheck = () => {
    return(
        <div>The app is working</div>
    )
}


export default HealthCheck;